import Rest from '../Rest'

export default class LegalEntityService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/legal_entities'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  // Bank Details
  saveBankDetail(id: Number, payload: any) {
    return this.post(`/${id}/bank_details`, payload).then(data => {
      return data
    })
  }

  deleteBankDetail(id: Number, bankDetailId: Number) {
    return this.delete(`/${id}/bank_details/${bankDetailId}`).then(data => {
      return data
    })
  }

  getAllBankDetails(id: Number) {
    return this.get(`/${id}/bank_details`).then(data => {
      return data
    })
  }
  //----

  // Teachers

  attachTeachers(id: Number, payload: any) {
    return this.post(`/${id}/teachers`, {ids: payload}).then(data => {
      return data
    })
  }

  deleteTeacher(id: Number, teacherId: Number) {
    return this.delete(`/${id}/teachers/${teacherId}`).then(data => {
      return data
    })
  }

  getAllTeachers(id: Number) {
    return this.get(`/${id}/teachers`).then(data => {
      return data
    })
  }

  //---Modalities
  attachModalities(id: Number, payload: any) {
    return this.post(`/${id}/modalities`, {ids: payload}).then(data => {
      return data
    })
  }

  deleteModality(id: Number, modalityId: Number) {
    return this.delete(`/${id}/modalities/${modalityId}`).then(data => {
      return data
    })
  }

  getAllModalities(id: Number) {
    return this.get(`/${id}/modalities`).then(data => {
      return data
    })
  }
  //----

  attachResponsable(id: Number, payload: any) {
    return this.post(`/${id}/responsable`, {ids: payload}).then(data => {
      return data
    })
  }

  destroyResponsable(id: Number, responsableId: Number) {
    return this.delete(`/${id}/responsable/${responsableId}`).then(data => {
      return data
    })
  }

  getAllResponsables(id: Number) {
    return this.get(`/${id}/responsable`).then(data => {
      return data
    })
  }

  // ---
  deleteImage(id, mediaId) {
    return this.delete(`/${id}/images/${mediaId}`).then(
      (response) => {
        return response
      }
    )
  }

  // --- Habilitação (KYC) — vale para os DOIS tipos de fornecedor
  //
  // As rotas neutras /kyc/* substituem as /professional/* desde o auto-cadastro
  // de parceiros: o backend decide os itens da checklist pela natureza
  // (person_type) da entidade. Os métodos *Professional* abaixo ficam como
  // alias até não sobrar chamador.

  kycChecklist(id: Number) {
    return this.get(`/${id}/kyc/checklist`).then(data => {
      return data
    })
  }

  /** Dados informados no cadastro, para a tela de análise. */
  kycDetails(id: Number) {
    return this.get(`/${id}/kyc/details`).then(data => {
      return data
    })
  }

  kycSubmitForReview(id: Number) {
    return this.post(`/${id}/kyc/submit_for_review`, {}).then(data => {
      return data
    })
  }

  kycApprove(id: Number, notes: string | null = null) {
    return this.post(`/${id}/kyc/approve`, { notes }).then(data => {
      return data
    })
  }

  kycReject(id: Number, reason: string) {
    return this.post(`/${id}/kyc/reject`, { reason }).then(data => {
      return data
    })
  }

  // --- Profissional autônomo (pessoa física)
  //
  // O profissional é uma linha de corp.legal_entities com person_type = 'NE', então
  // todo o CRUD acima serve a ele. O cadastro guiado (POST /professionals/register)
  // vive em ProfessionalService, que tem outro recurso base.

  /** @deprecated use kycChecklist — mantido até não sobrar chamador. */
  getProfessionalChecklist(id: Number) {
    return this.get(`/${id}/professional/checklist`).then(data => {
      return data
    })
  }

  submitProfessionalForReview(id: Number) {
    return this.post(`/${id}/professional/submit_for_review`, {}).then(data => {
      return data
    })
  }

  approveProfessional(id: Number, notes: string | null = null) {
    return this.post(`/${id}/professional/approve`, { notes }).then(data => {
      return data
    })
  }

  rejectProfessional(id: Number, reason: string) {
    return this.post(`/${id}/professional/reject`, { reason }).then(data => {
      return data
    })
  }

  // --- Região de atuação
  getServiceAreas(id: Number) {
    return this.get(`/${id}/service_areas`).then(data => {
      return data
    })
  }

  saveServiceArea(id: Number, payload: any) {
    return this.post(`/${id}/service_areas`, payload).then(data => {
      return data
    })
  }

  deleteServiceArea(id: Number, serviceAreaId: Number) {
    return this.delete(`/${id}/service_areas/${serviceAreaId}`).then(data => {
      return data
    })
  }

  /** Mapa de ocupação semanal das turmas do estabelecimento. */
  getOccupancyGrid(id: Number | String, weeks: Number = 4) {
    return this.get(`/${id}/occupancy/grid?weeks=${weeks}`)
  }

}
